import * as React from "react";
import Autocomplete from "react-autocomplete";
import AutocompleteInput from "../common/input/AutocompleteInput";
import { Link, withRouter } from "react-router-dom";
import WhatsNewHeadings from "./WhatsNewHeadings";
import * as d from "../../reducers/domainReducer";
import Cookies from "cookies-js";
import { connect } from "react-redux";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";

const Interactive_InApp_Tutorial = 'InteractiveInAppTutorial';  //cookie name for Interactive In App Site Tour

class WhatsNew extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            showMenu: false,
            showMenuApril: false
        };

    }

    componentDidMount() {
        logUI("MBHWeb.UI.WhatsNew.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    takeTour() {
        if (Cookies.get(Interactive_InApp_Tutorial)) {
            Cookies.set(Interactive_InApp_Tutorial, false, { path: '/' });
        }
        if (this.props.history) {
            this.props.history.push('/?whatsnew=1');
        }
    }

    render() {     
        let contentObject = [];  

        const { currentPharmacyUser, serverData } = this.props;

        const careOptionType = serverData && serverData.careOptions ? serverData.careOptions : "Convenient Care Options";
        const careOptionsImg = careOptionType.toLowerCase().split(" ");
        const imageSrc = "/images/" + careOptionsImg[0] + "-care-tile.jpg";

        const UrgentCare = '<div class="whats-new__content"><p>The ' + careOptionType + ' tile presents a full range of service options for “urgent care like” needs. Finding same day care is now easier than ever.  Within ' + careOptionType + ' you can receive care through:</p><ul class="angle-bullets"><li>In-Person Appointment – See available walk-in locations or appointments today for a doctor near you</li><li>eVisit – Complete an assessment in 5-10 minutes and receive a doctor response in less than an hour</li><li>Video Visit - Schedule a 20 minute video visit to receive care at your convenience (Note: only available to small pilot group in March release.  This will be expanded to all users in coming months)</li></ul><p><img class="img-fluid" alt="' + careOptionType + '" src="' + imageSrc + '" /></p></div>';      
        const EnhancedSearchScheduling = '<div class="whats-new__content"><p>You can now search by condition, treatment, or specialty and receive a list of both doctors and locations that meet your search criteria.   Online scheduling is also easier than ever.  The next 3 available time slots will show in the search results for many BSWH doctors and scheduling has been streamlined down to 3 short steps.</p></div>';
        const WhatsNew = '<div class="whats-new__content"><p>This section will highlight the key features that are included in each release.  Check back on occasion to learn about new offerings.</p></div>';

        contentObject.push({ ContentId: "Whatsnew_bswh1", ContentName: careOptionType, content: UrgentCare ? UrgentCare : '' });
        contentObject.push({ ContentId: "Whatsnew_bswh2", ContentName: "Enhanced Search & Scheduling", content: EnhancedSearchScheduling ? EnhancedSearchScheduling : '' });
        contentObject.push({ ContentId: "Whatsnew_bswh3", ContentName: "What's New", content: WhatsNew ? WhatsNew : '' });


        var RenderContent = contentObject.map(function (item, key) {
            return (
                <WhatsNewHeadings key={key} ContentId={item.ContentId} ContentName={item.ContentName} content={item.content} />             
            );
        }); 
        return (
            <div className="container-fluid body-content whats-new-container">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <h1 className="page-heading">What's New</h1>
                        <div className="row">
                            {!currentPharmacyUser ?
                            <div className="col-12">
                                <div className="info-banner">
                                    <div className="info-banner__cta">
                                        Get a detailed overview of some of the new website changes.
                                    </div>
                                    <div className="info-banner__button">
                                        <button className="btn btn-primary" onClick={() => this.takeTour()}>TAKE A QUICK TOUR</button>
                                    </div>
                                </div>
                            </div> : null}
                            <div className="col-12 col-md-4">
                                <div className="search">
                                    <div className={"il-group autocomplete-group"}>
                                        <Autocomplete wrapperStyle={{ display: 'flex' }}
                                            menuStyle={{
                                                borderRadius: '3px',
                                                boxShadow: '0 1px 7px 0 #C8C8C8',
                                                background: 'rgba(255, 255, 255, 0.9)',
                                                padding: '0',
                                                fontSize: '14px',
                                                position: 'fixed',
                                                overflow: 'auto',
                                                maxHeight: '250px',
                                                zIndex: '998'
                                            }}
                                            inputProps={{
                                                placeholder: "Search", className: "form-control",
                                                //onKeyUp: key => { if (key.keyCode === 13) this.search(value); },
                                                //onFocus: () => this.onFocus()
                                            }}
                                            items={[
                                                { label: 'Redesigned website', id: 1 },
                                                { label: 'Urgent Care Options', id: 2 }
                                            ]}
                                            //shouldItemRender={(item, value) => item.label.toLowerCase().indexOf(value.toLowerCase()) > -1}
                                            getItemValue={(item) => item.label}
                                            renderItem={(item, highlighted) =>
                                                (<div className="suggestion-item"
                                                    key={item.id}
                                                    style={{ backgroundColor: highlighted ? 'white' : 'white' }}>
                                                    {item.label}
                                                </div>)
                                            }
                                            value={this.state.value}
                                            onChange={(e) => this.setState({ value: e.target.value })}
                                            onSelect={(value) => this.setState({ value })}
                                        />
                                        <div className="il-label" aria-hidden="true">Search</div>
                                        <div className="input-icon-append">
                                            <span className="icon-search" />
                                        </div>
                                    </div>
                                </div>
                                <div className="il-group menu_heading">

                                    <div>
                                        <dl>
                                            <div className="month-heading" onClick={() => this.setState({ showMenu: !this.state.showMenu })}><dt>{this.state.showMenu ? <span className="icon-dd-up space-class" /> : <span className="icon-dd space-class" />}MARCH 2019</dt></div>
                                            {this.state.showMenu &&
                                                <div className="menuLinks">
                                                    <dd><a href="#Whatsnew_bswh1" className="menuLink">{careOptionType}</a></dd>
                                                    <dd><a href="#Whatsnew_bswh2" className="menuLink">Enhanced Search & Scheduling</a></dd>
                                                    <dd><a href="#Whatsnew_bswh3" className="menuLink">What's New</a></dd>
                                                {/*<dd><a href="#Whatsnew_bswh4" className="menuLink">“What’s New”</a></dd>
                                                    <dd><a href="#Whatsnew_bswh5" className="menuLink">“Help & Tutorials”</a></dd>*/}
                                                </div>
                                            }
                                        </dl>
                                    </div>
                                    {/*<dl>
                                        <div className="month-heading" onClick={() => this.setState({ showMenuApril: !this.state.showMenuApril })}><dt>{this.state.showMenuApril ? <span className="icon-dd-up space-class" /> : <span className="icon-dd space-class" />}APRIL 2019</dt></div>
                                        {this.state.showMenuApril &&
                                            <div className="menuLinks">
                                                <dd><a href="#Whatsnew_bswh6" className="menuLink">MyCare Tasks</a></dd>
                                            </div>
                                        }
                                    </dl>*/}
                                </div>
                            </div>

                            <div className="col-12 col-md-8">
                                <div className="row">
                                    <div className="col-12">  
                                        <h1 className="page-heading light" id="Whatsnew_march2019">March 2019</h1>
                                    </div>
                                </div>
                                {/*   <WhatsNewHeadings ContentId="Whatsnew_bswh1" ContentName="Redesigned Website" content={RedesignContent ? RedesignContent : ''} />
                                <WhatsNewHeadings ContentId="Whatsnew_bswh2" ContentName="Urgent Care Options" content={UrgentCare ? UrgentCare : ''} />
                                <WhatsNewHeadings ContentId="Whatsnew_bswh3" ContentName="Enhanced Search & Scheduling" content={EnhancedSearchScheduling ? EnhancedSearchScheduling : ''} />    */ }
                                {RenderContent}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        currentPharmacyUser: d.hydratePharmacyUser(state.domain.cpu),
        serverData: state.session.serverData
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WhatsNew);